/* page-design-studio.js — two progressive enhancements:
   1. Set --ds-hero-ratio and --ds-card-ratio from the loaded images, so
      future image swaps with different native dimensions just work.
   2. Set --ngv-header-clearance from the theme's rendered header (and
      announcement bar if present), so the page survives theme-setting
      changes (logo size, header style, announcement enabled).
   Both enhancements degrade silently: CSS holds sensible fallbacks. */
(function () {
  var root = document.getElementById('ngv-design-studio');
  if (!root) return;

  /* ---------- 1. Aspect-ratio observer ---------- */
  function setRatioFromImg(img, varName) {
    if (!img) return;
    function apply() {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (w > 0 && h > 0) root.style.setProperty(varName, w + ' / ' + h);
    }
    if (img.complete && img.naturalWidth) apply();
    else img.addEventListener('load', apply, { once: true });
  }
  setRatioFromImg(root.querySelector('.hero-bubble__img'), '--ds-hero-ratio');
  setRatioFromImg(root.querySelector('.card-img img'), '--ds-card-ratio');

  /* ---------- 2. iOS Safari orientation reflow ----------
     Placed BEFORE the header observer's early returns so it runs even
     on browsers without ResizeObserver or when theme header elements
     can't be found. After portrait→landscape→portrait, iOS Safari
     keeps grid columns at the landscape computed width; toggling
     display + reading offsetHeight forces a synchronous reflow.
     Two passes (50ms + 300ms) cover Safari and Chrome iOS rotation-
     event timing differences. */
  function forceReflow() {
    var d = root.style.display;
    root.style.display = 'none';
    void root.offsetHeight;
    root.style.display = d || '';
  }
  function onOrientation() {
    setTimeout(forceReflow, 50);
    setTimeout(forceReflow, 300);
  }
  window.addEventListener('orientationchange', onOrientation);
  if (window.matchMedia) {
    var mq = window.matchMedia('(orientation: portrait)');
    if (mq.addEventListener) mq.addEventListener('change', onOrientation);
    else if (mq.addListener) mq.addListener(onOrientation);
  }

  /* ---------- 3. Header clearance observer ---------- */
  if (!('ResizeObserver' in window)) return;
  var headerEls = [
    document.querySelector('.xo-announcement-bar'),
    document.querySelector('.xo-header__sticky')
  ].filter(Boolean);
  if (!headerEls.length) return;

  function updateClearance() {
    var total = 0;
    headerEls.forEach(function (el) {
      total += el.getBoundingClientRect().height;
    });
    /* Cap at 160px: defense against iOS Safari measuring a pre-hydration
       announcement-bar carousel (items stacked) or drawer-menu subtree as
       hundreds of pixels tall. CSS also clamps; this avoids writing a
       nonsense value to the CSS var in the first place. */
    if (total > 0) {
      var capped = total > 160 ? 160 : total;
      root.style.setProperty('--ngv-header-clearance', capped + 'px');
    }
  }

  var ro = new ResizeObserver(updateClearance);
  headerEls.forEach(function (el) { ro.observe(el); });
  updateClearance();
  /* Re-measure after full load (catches the xo-sticky hydration transition). */
  if (document.readyState === 'complete') updateClearance();
  else window.addEventListener('load', updateClearance);
})();
